// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__itExK","log":"ModalInventoryLogs_log__2t6Ws","date":"ModalInventoryLogs_date__3bcdL","userName":"ModalInventoryLogs_userName__3jyJw"};